"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useItemContext = exports.ItemContext = void 0;
const react_1 = require("react");
exports.ItemContext = (0, react_1.createContext)(undefined);
const useItemContext = () => {
    const value = (0, react_1.useContext)(exports.ItemContext);
    if (!value) {
        throw new Error('Can not find item context. Did you forget to wrap your component with <ItemContext.Provider/>?');
    }
    return value;
};
exports.useItemContext = useItemContext;
//# sourceMappingURL=ItemContext.js.map